<template>
  <div class="">
    <button class="bar" @click="display = !display">
      <i class="fas fa-bars"></i>
    </button>
    <div :class="{'menu':true,'display':display}">
      <div class="content">
        <div class="user" v-if="user.id">
          <div class="photo" :style="{backgroundImage:`url(${user.data.photoURL})`}"></div>
          <p class="name">{{ user.data.displayName }}</p>
        </div>
        <div class="user" v-if="!user.id">
          <p class="mb-2">尚未登入</p>
          <a class="name" href="#" @click="display = !display"
          data-toggle="modal" data-target="#login-modal">
            登入/註冊
          </a>
        </div>
        <ul class="list mt-5">
          <li @click="display = !display">
            <router-link to="/">
              <i class="fas fa-skull-crossbones"></i> 挑戰海盜
            </router-link>
          </li>
          <li @click="display = !display">
            <router-link to="/ranking">
              <i class="fas fa-award"></i> 每週排行榜
            </router-link>
          </li>
          <li @click="display = !display">
            <a target="_blank" href="https://forms.gle/ogzpetD3RoKF63Zu8">
              <i class="fas fa-file-alt"></i> 意見回饋
            </a>
          </li>
          <!-- <li @click="display = !display">
            <router-link to="/personal">
              個人空間
            </router-link>
          </li>
          <li @click="display = !display">
            <router-link to="/message">
              留言板
            </router-link>
          </li> -->
        </ul>
      </div>
      <div class="foot">
        <button class="btn btn-small btn-success" @click="signOut()" v-if="user.id">
          登出
        </button>
      </div>
      <button class="exit"  @click="display = false">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal fade" id="login-modal" tabindex="-1" role="dialog"
    aria-labelledby="loginLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button class="btn btn-lg btn-outline-primary"
            @click="loginClick()" type="submit">
            <i class="fab fa-google"></i> 使用 google 繼續
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import firebase from 'firebase/app';

export default {
  props: ['user'],
  data() {
    return {
      display: false,
    };
  },
  methods: {
    toggleMenu() {
      const vm = this;
      vm.display = !vm.display;
    },
    signOut() {
      const vm = this;
      firebase.auth().signOut().then(() => {
        // 登出
      }, (error) => {
        console.log('登出失敗', error);
      });
      vm.display = !vm.display;
    },
    loginClick() {
      const fireAuth = firebase.auth();

      // Start a sign in process for an unauthenticated user.
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
      fireAuth.signInWithPopup(provider).then((result) => {
        const user = { user: result.user }; // 檢測
        $('#login-modal').modal('hide');
        firebase.database().ref(`users/${user.user.uid}`).set({
          email: user.user.email,
          displayName: user.user.displayName,
          photoURL: user.user.photoURL,
        });
        console.log('登入成功~');
      }).catch((ero) => {
        // 處理 帳號已經存在於其他登入方式時
        if (ero.code === 'auth/account-exists-with-different-credential') {
          // 取得當初此Email的登入方式
          const { email } = ero;
          console.log('google登入錯誤-使用者信箱：', email);
        }
      });
    },
  },
  created() {
    // this.LoginOrNot()
    // this.signOut()
  },
};
</script>

<style lang="scss" scoped>
  .menu{
    position: fixed;
    width: 320px;
    background-color: #222;
    height: 100vh;
    left: -320px;
    top: 0;
    padding: 50px 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: all 0.3s ease-in-out;
    z-index: 101;
    box-shadow: 0 10px 10px rgba(0,0,0,0.5);
    overflow: hidden;
    &:after{
      content: url('../assets/img/flex-target-lg-2.svg');
      filter: brightness(0%);
      opacity: 0.4;
      position: absolute;
      bottom: 50px;
      left: 0;
      width: 500px;
    }
    &.display{
      left: 0;
    }
    .exit{
      position: absolute;
      top: 10px;
      right: 20px;
      color: #fff;
      background-color: transparent;
      border: none;
      font-size: 36px;
      z-index: 1;
    }
    .content{
      position: relative;
      z-index: 1;
      .user{
        color: #aaa;
        display: flex;
        align-items: center;
        flex-direction: column;
        .photo{
          background-size: cover;
          width: 100px;
          height: 100px;
          border-radius: 50%;
          border: 5px solid rgba(0,0,0,0.5);
          margin-bottom: 10px;
        }
        .name{
          color: #fff;
        }
      }
      .list{
        a{
          color: #fff;
          padding: 15px 0;
          display: flex;
          align-items: center;
          border-top: 1px dashed rgba(255,255,255,0.5);
          transition: all 0.2s ease-in-out;
          i{
            font-size: 24px;
            margin-right: 10px;
          }
          &:hover {
            text-decoration: none;
            opacity: 0.8;
          }
        }
      }
    }
    .foot{
      position: relative;
      z-index: 1;
    }
  }
  .bar{
    position: fixed;
    top: 15px;
    left: 15px;
    z-index: 100;
    background-color: transparent;
    border: none;
    background-color: rgba(255,255,255,0.5);
    padding: 15px 20px;
    font-size: 24px;
    i{
      text-shadow: 0 0 6px rgba(255,255,255,0.5)
    }
  }
</style>
